'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps, _dec2, _dec3, _class3, _class4, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _components = require('../../components');

var _TargetDateGrid = require('./TargetDateGrid.css');

var _TargetDateGrid2 = _interopRequireDefault(_TargetDateGrid);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetDateGridItem = (_dec = (0, _reactCssModules2.default)(_TargetDateGrid2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateGridItem, _Component);

  function TargetDateGridItem(props) {
    (0, _classCallCheck3.default)(this, TargetDateGridItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TargetDateGridItem.__proto__ || (0, _getPrototypeOf2.default)(TargetDateGridItem)).call(this, props));

    _initialiseProps.call(_this);

    var fund = props.fund,
        gradeField = props.gradeField;


    var url = _this.makeUrl(fund);
    var charGrade = fund[gradeField].toString();
    _this.state = {
      fund: fund,
      gradeField: gradeField,
      url: url,
      charGrade: charGrade
    };
    return _this;
  }

  (0, _createClass3.default)(TargetDateGridItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}

    //

  }, {
    key: 'render',

    //
    value: function render() {
      var _state = this.state,
          fund = _state.fund,
          gradeField = _state.gradeField,
          url = _state.url,
          charGrade = _state.charGrade;
      //

      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        null,
        _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 12, sm: 1 }),
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { styleName: 'companies-box-wrap', xs: 12, sm: 10 },
          _react2.default.createElement(
            'div',
            { styleName: 'companies-box' },
            _react2.default.createElement(
              'div',
              { styleName: 'box-title-wrap' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: url,
                  styleName: 'companies-link',
                  title: fund.strategy_name + ' 2050 | ' + _config2.default.app.title
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'box-title' },
                  _react2.default.createElement(
                    'b',
                    null,
                    fund.strategy_name
                  ),
                  fund.sustainable_investment ? _react2.default.createElement(
                    'span',
                    { styleName: 'leaf' },
                    _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-leaf' })
                  ) : null
                )
              ),
              _react2.default.createElement(_components.TargetDateLinks, { funds: this.props.funds, strategyName: fund.strategy_name })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'box-grade-wrap' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: url,
                  styleName: 'companies-link',
                  title: fund.strategy_name + ' | ' + _config2.default.app.title
                },
                _react2.default.createElement(_components.Grade, { grade: fund[gradeField], block: true })
              )
            )
          )
        ),
        _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 12, sm: 1 })
      );
    }
  }]);
  return TargetDateGridItem;
}(_react.Component), _class2.propTypes = {
  fund: _react.PropTypes.object.isRequired,
  gradeField: _react.PropTypes.string.isRequired,
  funds: _react.PropTypes.array
}, _initialiseProps = function _initialiseProps() {
  this.makeUrl = function (fund) {
    var sName = _format2.default.sanitize(fund.fund_legal_name);
    var sTicker = fund.ticker || 'N';
    return _config2.default.routes.fund + '/' + sName + '/' + sTicker + '/' + _config2.default.profilePath + '/' + fund.fund_id + '/' + fund.investment_vehicle_id;
  };
}, _temp)) || _class);
var TargetDateGrid = (_dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.fundsByStrategy.result,
    searching: state.fundsByStrategy.loading,
    searched: state.fundsByStrategy.loaded,
    error: state.fundsByStrategy.error
  };
}, searchActions), _dec3 = (0, _reactCssModules2.default)(_TargetDateGrid2.default, { allowMultiple: true }), _dec2(_class3 = _dec3(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(TargetDateGrid, _Component2);

  function TargetDateGrid(props) {
    (0, _classCallCheck3.default)(this, TargetDateGrid);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (TargetDateGrid.__proto__ || (0, _getPrototypeOf2.default)(TargetDateGrid)).call(this, props));

    _this2.groupSortFundsSetState = function (f) {
      var groupedSortedFunds = _this2.groupSortFunds(f);
      if (groupedSortedFunds) {
        _this2.setState({ fundsByStrategy: groupedSortedFunds });
      }
    };

    _this2.groupSortFunds = function (f) {
      var d = {};
      if (f && Array.isArray(f) && f.length > 0) {
        for (var i = 0; i < f.length; i++) {
          var currFund = f[i];
          var currStrategy = currFund.strategy_name;
          if (!(d[currStrategy] && Array.isArray(d[currStrategy]))) {
            d[currStrategy] = [];
          }
          d[currStrategy].push(currFund);
        }
        //
        for (var p = 0; p < (0, _keys2.default)(d).length; p++) {
          var sortStrategy = (0, _keys2.default)(d)[p];
          var currFundsList = d[sortStrategy];
          currFundsList.sort(function (a, b) {
            return a.fund_legal_name.localeCompare(b.fund_legal_name);
          });
          d[sortStrategy] = currFundsList;
        }
        return d;
      }
      return null;
    };

    _this2.state = {
      targetDateSeriesList: [].concat(_config2.default.targetDateSeries),
      fundsByStrategy: {}
    };
    return _this2;
  }
  //


  (0, _createClass3.default)(TargetDateGrid, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      // unique strategy names of each target date series
      var strategy_names = [].concat((0, _toConsumableArray3.default)(new _set2.default(_config2.default.targetDateSeries.map(function (x) {
        return x.strategy_name;
      }))));
      // call API
      this.props.getFundsByStrategy(strategy_names);
    }
    //

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.groupSortFundsSetState(nextProps.result);
    }
    //

  }, {
    key: 'render',


    //
    value: function render() {
      var _this3 = this;

      if (!this.props.result) {
        // 
        return _react2.default.createElement(
          'div',
          { style: { position: 'relative' } },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, position: 'absolute', top: '4.0rem' },
            loaded: false
          })
        );
      }

      var targetDateSeriesList = this.state.targetDateSeriesList;


      var gradeField = {
        'Fossil Free Funds': 'grade_fossil',
        'Deforestation Free Funds': 'grade_deforestation',
        'Gender Equality Funds': 'grade_gender_equality',
        'Gun Free Funds': 'grade_guns',
        'Prison Free Funds': 'grade_prison_industrial_complex',
        'Weapon Free Funds': 'grade_military',
        'Tobacco Free Funds': 'grade_tobacco'
      }[_config2.default.app.title] || null;

      var gradeName = {
        'Fossil Free Funds': 'Fossil fuel',
        'Deforestation Free Funds': 'Deforestation',
        'Gender Equality Funds': 'Gender equality',
        'Gun Free Funds': 'Civilian firearm',
        'Prison Free Funds': 'Prison industrial complex',
        'Weapon Free Funds': 'Military weapon',
        'Tobacco Free Funds': 'Tobacco'
      }[_config2.default.app.title] || null;

      if (!gradeField) {
        return null;
      }

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'companies' },
        _react2.default.createElement('div', { styleName: 'companies-anchor', id: 'companies' }),
        _react2.default.createElement(
          'div',
          { styleName: 'companies-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'companies-title' },
            'Target date funds'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'companies-info' },
            'Target date funds are groups of funds, where each fund in the series targets a different mix of stocks and bonds for investors with different retirement time horizons. The default option in employer-offered retirement plans is often a target date fund series. Below are ',
            _config2.default.targetDateSeries.length,
            ' of the largest target date fund series, rated using the 2050 fund.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'companies-boxes' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 11 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'grade-label' },
                  gradeName,
                  ' grade',
                  _react2.default.createElement('br', null),
                  'for 2050 fund'
                )
              ),
              _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 12, sm: 1 })
            ),
            targetDateSeriesList.map(function (fund, idx) {
              return _react2.default.createElement(TargetDateGridItem, {
                key: 'target-date-grid-item-' + idx,
                fund: fund,
                gradeField: gradeField,
                funds: _this3.state.fundsByStrategy[fund.strategy_name]
              });
            })
          )
        )
      );
    }
  }]);
  return TargetDateGrid;
}(_react.Component), _class4.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _temp2)) || _class3) || _class3);
exports.default = TargetDateGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/TargetDateGrid/TargetDateGrid.js
// module id = 1394
// module chunks = 0